import { General } from "../../siteManagement/general.js";
import { Config } from "../core/config/config.js";
import { Helper } from "../core/util/helper.js";
import { Dialog, DialogProps } from "../core/components/dialog.js";
import { ComponentHelper } from "../core/util/componentHelper.js";
import { FieldInstance } from "../core/components/field.js";
import { IconsComboBox } from "../core/components/iconComboBox.js";
import { IconPicker } from "../core/components/iconPicker.js";
import { ComboBox } from "../core/components/comboBox.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { TextBox } from "../core/components/textBox.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { Context } from "../core/components/commonApp.js";
import React from "react"
import ReactDOM from "react-dom"
interface BookmarkBtnProps {
    contextType: string;
    additionalData?: any;
}
export class BookmarkBtn extends React.Component<BookmarkBtnProps, any>{
    private sheet = General.Sheet.Manager.getTopMostSheet();


    private getDefaultValues = () => {
        let name = "";
        let icon = "circle-bookmark";
        let category = Helper.getTranslation("Server.Other");
        let url = window.location.href.replace(window.location.origin, "").replace(Config.baseUrl, "");

        let arr = this.sheet.getTitle().split(' - ');
        if (arr.length > 1) {
            arr.shift();
            name = arr.join(' - ')
        } else {
            name = this.sheet.getTitle();
        }
        console.log(this.props.additionalData)
        switch (this.props.contextType) {
            case "project":
                icon = "folder-open";
                category = Helper.getTranslation("Field.Enum.LinkedType.Projects");
                break;
            case "ticket":
                icon = "exclamation-square";
                category = Helper.getTranslation("Auftrag.Vorgänge");
                break;
            case "machine":
                icon = "cogs"
                category = Helper.getTranslation("Field.fstasks.machines");
                break;
            case "address":
                icon = "home";
                category = Helper.getTranslation("WebSMS.DataExchangeModule.EditTemplate.Addresses");
                break;
            case "resourcePlanning":
                icon = "calendar-circle-user";
                category = Helper.getTranslation("Field.Enum.LinkedType.Assignments");
                break;
            case "scheduler":
                icon = "calendar-range";
                category = Helper.getTranslation("Einsatz.Plantafel");
                name = Helper.getTranslation("Einsatz.Plantafel");
                const filter = Helper.loadDataFromStorage("current_favorite_filter");
                if (Helper.hasValue(filter) && !Helper.isNullOrEmpty(filter.Name)) {
                    name = filter.Name;
                    url = `ResourcePlanningScheduler?filterId=${filter.Id}`
                }
                break;
            case "search":
                icon = "search";
                category = name;
                const searchType = this.props.additionalData.searchType;
                const searchFilter = Helper.loadDataFromStorage(`SEARCH_TEMPLATE_DEFAULT_${searchType}_${Config.user.userName}`);
                if (searchFilter && !Helper.isNullOrEmpty(searchFilter.name)) {
                    category = name;
                    name = searchFilter.name;
                }
                break;
            case "contact":
                icon = "id-badge";
                category = Helper.getTranslation("Field.Adresse.ansprechpartner");
                break;
            case "resource":
                icon = "person";
                category = Helper.getTranslation("Ressource.Ressourcen");
                break;
            default:
                console.log(this.props.contextType)
                break;
        }
        return { icon, name, category, url }
    }

    private onClick = () => {
        const targetElement = $("<div>");
        $("body").append(targetElement);
        const root = ReactDOM["createRoot"](targetElement[0]);

        const afterSave = (data) => {
            root.unmount();
            targetElement[0].remove();
            //createNewMenuEntry(data);
        }

        const { icon, name, category, url } = this.getDefaultValues();
        root.render(<BookmarkDialog afterSave={afterSave} icon={icon} name={name} category={category} url={url} />);
    }

    render() {
        return (
            ReactDOM.createPortal(
                <div onClick={this.onClick} title={Helper.getTranslation("Bookmarks.Add")}>
                    <i className="fa-light fa-circle-bookmark fa-2x"></i>
                </div>,
                this.sheet.elements.getBookmarkRef()[0]
            )
        );
    }
}

interface BookmarkDialogProps {
    afterSave: (data) => void;
    name: string;
    icon: string;
    category: string;
    url: string;

}
class BookmarkDialog extends React.Component<BookmarkDialogProps, { icon: string, category: string, name: string }>{
    private dialogRef: Dialog;
    private dialogProps: DialogProps = {
        title: Helper.getTranslation("Bookmarks.NewBookmark"),
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    this.save();
                    return false;
                },
                primary: true
            }
        ],
        open: true,
        afterClose: () => { },
        width: 500
    };
    private factory = ComponentHelper.createFactory();
    constructor(props: BookmarkDialogProps) {
        super(props)
        this.state = {
            category: props.category,
            icon: props.icon,
            name: props.name
        }
    }

    private save = async () => {

        const obj = {
            PwUser: Config.user.userName,
            Name: this.state.name,
            Icon: this.state.icon,
            URL: this.props.url,
            Category: this.state.category
        };

        const { Code, Message } = await HTTPService.post<JsonResultClass>("Bookmark/Save", {
            PwUser: Config.user.userName,
            Name: this.state.name,
            Icon: this.state.icon,
            URL: this.props.url,
            Category: this.state.category
        });
        if (Code == 0) {
            NotificationHelper.showInfoMessage(Helper.getTranslation("Bookmarks.Reload"))
            this.dialogRef.close();
            this.props.afterSave(obj);
        } else {
            NotificationHelper.showErrorMessage(Message);
        }
    }

    private renderIconTextBox = () => {
        return (
            <FieldInstance label={Helper.getTranslation("WebSMS.ResourcePlanningScheduler.Icon.Icon")} noHover={true}>
                <IconPicker value={this.state.icon} onChange={(value) => { this.setState({ icon: value }) }} dataSourceUrl={"Bookmark/GetIcons"} />
                {/*<IconsComboBox value={this.state.icon} onChange={(value) => { this.setState({ icon: value }) }} dataSourceUrl={"Bookmark/GetIcons"} />*/}
            </FieldInstance>
        );
    }

    private checkButtonAvailability = () => {
        const button = document.querySelector(".k-dialog button.k-button.k-button-solid-primary");
        if (Helper.isNullOrEmpty(this.state.name) || Helper.isNullOrEmpty(this.state.icon) || Helper.isNullOrEmpty(this.state.category)) {
            button.setAttribute("disabled", "disabled")
        } else {
            button.removeAttribute("disabled");
        }
    }

    private renderCatergoryCombobox = () => {
        return (
            <FieldInstance label={Helper.getTranslation("Field.Dokument.kategid")} noHover={true}>
                <CategoryCombobox onChange={(category) => { this.setState({ category: category }) }} value={this.state.category} />
            </FieldInstance>
        );
    }

    private renderNameTextbox = () => {
        const props = this.factory.getDefaultTextBoxProps();
        props.value = this.state.name;
        props.onChange = (_, value) => {
            this.setState({ name: value })
        }
        props.field.triggerOnChange = true;
        return (
            <FieldInstance label={Helper.getTranslation("BrowserTitle.Resource.Available")} noHover={true}>
                <TextBox {...props} />
            </FieldInstance>
        );

    }

    componentDidMount() {
        this.checkButtonAvailability();
    }

    componentDidUpdate() {
        this.checkButtonAvailability();
    }

    render() {
        return (
            <Dialog {...this.dialogProps} ref={(ref) => { this.dialogRef = ref }}>
                {this.renderIconTextBox()}
                {this.renderCatergoryCombobox()}
                {this.renderNameTextbox()}
            </Dialog>
        );
    }
}
interface CategoryComboboxProps {
    value: string;
    onChange: (value: string) => void;
}
function CategoryCombobox(props: CategoryComboboxProps) {
    const MAXLENGTH = Config.settings.bookmarks.maxAmount;

    let ref: HTMLInputElement;
    let comboBox: kendo.ui.ComboBox;

    const [showMessage, setShowMessage] = React.useState(false)

    function onDataBound(ev) {
        const dataSource: string[] = ev.sender.dataSource.data().map(item => item.Value);
        if (dataSource.length >= MAXLENGTH) {
            //Textbox auf readonly schalten
            const textBox = document.querySelector("#category_dropdown input.k-input-inner");
            textBox.setAttribute("readonly", "readonly");

            //props.value überprüfen
            const tmp = dataSource.find(f => f.trim() == props.value.trim())
            if (Helper.isNullOrEmpty(tmp)) {
                comboBox.value(dataSource[0]);
                props.onChange(dataSource[0])
            }

            //Meldung dazuschalten
            setShowMessage(true);
        }
    }

    React.useEffect(() => {
        comboBox = $(ref).kendoComboBox({
            dataTextField: "Value",
            dataValueField: "Value",
            filter: "contains",
            suggest: true,
            value: props.value,
            dataBound: onDataBound,
            clearButton: false,
            change: (ev) => {
                const value = ev.sender.value();
                console.log(value)
                props.onChange(value)
            },
            dataSource: {
                type: "json",
                serverFiltering: true,
                transport: {
                    read: {
                        url: `${Config.baseUrl}Bookmark/GetCategories`,
                        dataType: "json",
                        data: () => {
                            let search: any = "";
                            const el = $(ref).data("kendoComboBox");
                            if (el) {
                                search = el.input.val();
                            }
                            return {
                                search: search
                            }
                        }
                    }
                },
                schema: {
                    type: "json",
                    data: "Data",
                    model: {
                        fields: {
                            Value: { field: "Value", type: "string" },
                            Key: { field: "Key", type: "string" },
                        }
                    }
                }
            }
        }).data("kendoComboBox");


    }, [])

    return (
        <div id="category_dropdown" style={{ display: "flex", flexDirection: "column" }}>
            <input style={{ width: "100%" }} ref={(r) => { ref = r }} ></input>
            <div style={{ display: showMessage ? "flex" : "none", fontSize: "10px", flexDirection: "row-reverse", color: "#F89406" }}>
                <label>
                    {Helper.getTranslation("Bookmarks.MaxLenght").replace("{x}", MAXLENGTH.toString())}
                </label>
            </div>
        </div>
    );
}